import { Link } from "wouter";
import { Globe, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEOHead } from "@/components/seo-head";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white text-slate-900 font-sans antialiased flex flex-col">
      <SEOHead
        title="Page Not Found — Vyzle"
        description="The page you're looking for doesn't exist."
        noindex
      />
      {/* Header */}
      <header className="border-b border-slate-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-center">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-emerald-600 flex items-center justify-center text-white">
              <Globe className="w-3.5 h-3.5" />
            </div>
            <span className="text-base font-bold text-slate-900">Vyzle</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="text-7xl sm:text-8xl font-black text-emerald-600 mb-4">404</div>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">Page not found</h1>
          <p className="text-sm sm:text-base text-slate-500 mb-8 leading-relaxed">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link href="/">
              <Button className="h-11 px-6 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg">
                <Home className="w-4 h-4 mr-2" />
                Go Home
              </Button>
            </Link>
            <Link href="/support">
              <Button variant="outline" className="h-11 px-6 rounded-lg border-slate-200 text-slate-600 hover:bg-slate-50">
                Visit Support
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-100 py-6">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 flex justify-center">
          <div className="text-xs text-slate-400">&copy; {new Date().getFullYear()} Vyzle</div>
        </div>
      </footer>
    </div>
  );
}
